import * as React from 'react';
import {connect, Dispatch} from "react-redux";
import {fetchJobEvents} from "../../../../store/action/job/job";
import JobFilesAttachedEvent from "../../../../model/job/event/JobFilesAttachedEvent";
import CommonStreamItem, {StreamItemAction} from "../../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import RemoveFilesConfirmation from "../../../activityStream/items/RemoveFilesConfirmation";
import {api} from "../../../../api/api";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import Toast from "../../../helper/Toast";
import TextUtils from "../../../../utils/TextUtils";

interface ComponentProps {
	/**
	 * Job activity to display.
	 */
	activity: JobFilesAttachedEvent;
}

interface DispatchProps {
	fetchJobEvents: (jobId: string) => void
}

interface State {
	confirmationVisible: boolean
}

type Props = ComponentProps & DispatchProps;

class JobFilesAttachedItem extends React.PureComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			confirmationVisible: false
		};
	}

	render() {
		const activeAttachments = this.props.activity.data.attachments.filter(a => !a.deleted.getOrElse(false));
		return (
			<>
				<CommonStreamItem event={this.props.activity} actions={this.getActions(activeAttachments.length)}/>
				{this.state.confirmationVisible && <RemoveFilesConfirmation attachments={activeAttachments}
																			hideModal={this.hideConfirmationModal}
																			removeFiles={this.removeFiles}/>}
			</>
		)
	}

	hideConfirmationModal = () => this.setState({confirmationVisible: false})

	getActions(activeAttachmentsCount: number): StreamItemAction[] {
		const actions: StreamItemAction[] = [];
		if (activeAttachmentsCount > 0) {
			actions.push(
				new StreamItemAction(TextUtils.addSIfPlural("Remove file", activeAttachmentsCount), this.onRemoveAttachments))
		}
		return actions
	}

	onRemoveAttachments = (evt: React.MouseEvent<HTMLSpanElement>) => {
		evt.stopPropagation();
		this.setState({confirmationVisible: true})
	}

	removeFiles = (ids: string[]) => {
		api.instance.jobApi.removeFiles(this.props.activity.jobId, ids)
			.then(() => {
				this.setState({confirmationVisible: false})
				this.props.fetchJobEvents(this.props.activity.jobId);
				Toast.success("Files removed", "Remove files");
			}).catch(e => notifyBugsnagAndShowToast(e, "Remove files"))
	}

}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchJobEvents: (jobId: string) => dispatch(fetchJobEvents(jobId, () => {}, () => {}))
	}
}

export default connect(null, mapDispatchToProps)(JobFilesAttachedItem);